import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MojoNotesService } from 'mojo-irp-notes/lib/mojo-notes.config';
import { NotesFiltersInterface } from 'mojo-irp-notes/lib/models/notes-filters';
import { Observable } from 'rxjs';
import { Pagination } from '../models/pagination';
import { Note, PersistedNote } from 'mojo-irp-notes';

@Injectable({
  providedIn: 'root',
})
export class NotesService extends ApiService implements MojoNotesService {
  constructor() {
    super();
    this.url = 'notes/';
  }

  getNotes(notesFilters: NotesFiltersInterface): Observable<Pagination<Note>> {
    const pathParams = this.getParams(notesFilters);
    const params = {
      userGenerated: notesFilters.userGenerated,
      systemGenerated: notesFilters.systemGenerated,
      pageSize: notesFilters.pageSize,
      pageNumber: notesFilters.pageNumber,
      anonymization: notesFilters.anonymised,
      search: notesFilters.searchPhrases.length > 0 ? notesFilters.searchPhrases.toString() : '',
    };

    params.pageSize = 10;
    return this.get({ url: `${pathParams.subjectType}/${notesFilters.entityExternalId}`, params });
  }

  createNote(note: Note): Observable<Note> {
    return this.post({ body: note });
  }

  patchNote(note: PersistedNote): Observable<Note> {
    return this.patch({ url: `${note.id}`, body: note });
  }

  archive(note: PersistedNote): Observable<Note> {
    return this.patch({ url: `${note.id}/archive` });
  }

  private getParams(noteFilers: NotesFiltersInterface) {
    return { subjectType: noteFilers.id, subjectId: noteFilers.subjectId };
  }
}
